<template>
  <v-card>
    <v-card-text>
      <strong>Shipping Information</strong><br>
      <v-container fluid grid-list-sm>
        <v-layout row wrap>
          <shipping-address v-for="(address) in addresses"
                            :key="address.id"
                            :address="address"
                            @edit="editAddressInfo"
                            @delete="deleteAddressInfo"/>
          <add-card @edit="editAddressInfo" method="edit" :value="defaultAddress">
            Add Shipping Information
          </add-card>
        </v-layout>
      </v-container>
    </v-card-text>
    <shipping-address-form v-model="showShippingDialog"
                      :address="selectedAddress"
                      @update="selectedAddress = $event"
                      @save="saveAddressInfo"
                      @close="showShippingDialog = false"
                      @delete="deleteAddressInfo"/>
  </v-card>
</template>

<script>
import api from '@/api/gungho'
import Events from '@/api/events'
import ShippingAddress from './shipping-address'
import ShippingAddressForm from './shipping-address-form'
import AddCard from './add-card'

export default {
  components: {
    'shipping-address': ShippingAddress,
    'shipping-address-form': ShippingAddressForm,
    'add-card': AddCard
  },

  data () {
    return {
      addresses: [],
      showShippingDialog: false,
      selectedAddress: {},
      defaultAddress: {}
    }
  },

  beforeMount () {
    this.loadAddresses()
  },

  methods: {
    loadAddresses () {
      api.userAddresses().then(data => {
        this.addresses = data.addresses
      }).catch(error => {
        console.log(error)
      })
    },

    editAddressInfo (address) {
      this.selectedAddress = address
      this.showShippingDialog = true
    },

    saveAddressInfo (address) {
      console.log('Shipping Addresses Save Address Info')
      address.address_type = 'shipping'
      api.saveAddressInfo(address).then(data => {
        this.closeDialog()
        Events.$emit('toast', 'Saved Address')
      }).catch(error => {
        Events.$emit('error', error)
        console.log(error)
      })
    },

    deleteAddressInfo (address) {
      this.$confirm(`Delete this address?`).then(confirmed => {
        if (!confirmed) return
        api.deleteAddressInfo(address.id).then(data => {
          this.closeDialog()
          Events.$emit('toast', 'Deleted Address')
        }).catch(error => {
          console.log(error)
        })
      })
    },

    closeDialog () {
      this.showShippingDialog = false
      this.loadAddresses()
    }
  }
}
</script>



// WEBPACK FOOTER //
// shipping-addresses.vue?12bcb4bc